import * as MuiIcons from "@mui/icons-material";
import { CircleOutlined } from "@mui/icons-material";

// `@mui/icons-material` exports every icon by name. The Permissions > Menu Icons
// page enumerates this same module, so any name an operator can pick there
// resolves here too. Unknown / empty names fall through to a neutral dot so
// a missing icon never crashes the layout.
const ICON_REGISTRY = MuiIcons as unknown as Record<string, React.ElementType>;

// Re-exported so the Permissions > Menu Icons page (and any future picker) can
// iterate the catalog without re-importing the whole MUI module itself.
export const SIDEBAR_ICONS = ICON_REGISTRY;

interface Props {
  name?: string | null;
}

const SidebarIcon = ({ name }: Props) => {
  const Component = (name && ICON_REGISTRY[name]) || CircleOutlined;

  return <Component fontSize="small" />;
};

export default SidebarIcon;
